// extracted by mini-css-extract-plugin
export default {"schoolsTable":"SvE7gbge2N8_akRWqj5Q"};